<section class="league-form-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle"></app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>
  <div class="admin-feedback admin-feedback--success" *ngIf="feedbackSuccess">
    {{ feedbackSuccess }}
  </div>

  <form class="league-form admin-surface" (ngSubmit)="submit()">
    <div class="league-form__grid">
      <label>
        <span>Nome da liga</span>
        <input class="admin-input" name="name" [(ngModel)]="league.name" required />
      </label>

      <label>
        <span>Início</span>
        <input
          class="admin-input"
          type="datetime-local"
          name="startsAtLocal"
          [(ngModel)]="startsAtLocal"
          required />
      </label>

      <label>
        <span>Tipo</span>
        <select class="admin-input" name="leagueType" [(ngModel)]="league.league_type" (change)="onTypeChange()">
          <option value="DAILY">Daily</option>
          <option value="SERIES">Series</option>
        </select>
      </label>

      <label>
        <span>Acesso</span>
        <select class="admin-input" name="leagueAccess" [(ngModel)]="league.league_access" (change)="onAccessChange()">
          <option value="ALL">Todos</option>
          <option value="CREATORS">Creators</option>
          <option value="STAFF">Staff</option>
        </select>
      </label>

      <label>
        <span>Custo de entrada</span>
        <input class="admin-input" type="number" name="entryCost" [(ngModel)]="league.entry_cost" min="0" />
      </label>

      <label>
        <span>Rounds</span>
        <input class="admin-input" type="number" name="rounds" [(ngModel)]="league.rounds" readonly />
      </label>

      <label>
        <span>Duração do round (horas)</span>
        <input
          class="admin-input"
          type="number"
          name="roundDuration"
          [(ngModel)]="league.round_duration"
          [readonly]="league.league_type === 'SERIES'"
          [min]="league.league_type === 'SERIES' ? 5 : 2"
          [max]="league.league_type === 'SERIES' ? 5 : 4" />
      </label>

      <label>
        <span>Mínimo de jogadores</span>
        <input class="admin-input" type="number" name="minimumPlayers" [(ngModel)]="league.minimum_players" readonly />
      </label>

      <label>
        <span>Boosts grátis</span>
        <input class="admin-input" type="number" name="freeBoosts" [(ngModel)]="league.available_free_boosts" min="0" />
      </label>

      <label>
        <span>Boosts pagos</span>
        <input class="admin-input" type="number" name="paidBoosts" [(ngModel)]="league.available_paid_boosts" min="0" />
      </label>

      <label>
        <span>Cashback</span>
        <input class="admin-input" type="number" name="cashback" [(ngModel)]="league.cashback" min="0" />
      </label>

      <label class="league-form__cover">
        <span>Capa da liga</span>
        <input type="file" accept="image/*" (change)="onCoverSelected($event)" />
        <small>Se não selecionar, será enviada a imagem padrão automaticamente.</small>
      </label>
    </div>

    <label class="league-form__description">
      <span>Descrição</span>
      <textarea class="admin-input" rows="4" name="description" [(ngModel)]="league.description" required></textarea>
    </label>

    <label class="league-form__description">
      <span>Regras</span>
      <textarea class="admin-input" rows="4" name="rules" [(ngModel)]="league.rules"></textarea>
    </label>

    <div class="league-form__owner admin-surface">
      <h3>Owner da liga</h3>
      <div class="league-form__owner-search">
        <input
          class="admin-input"
          [(ngModel)]="ownerSearch"
          name="ownerSearch"
          placeholder="Buscar owner por username/email" />
        <button type="button" class="admin-btn admin-btn--secondary" (click)="searchOwners()">Buscar</button>
      </div>
      <p *ngIf="selectedOwnerLabel">Selecionado: {{ selectedOwnerLabel }}</p>
      <div class="league-form__owner-list">
        <button type="button" class="owner-chip" *ngFor="let owner of ownerOptions" (click)="selectOwner(owner)">
          {{ owner.username }} ({{ owner.email }}) #{{ owner.id }}
        </button>
      </div>
    </div>

    <div class="league-form__footer">
      <button type="button" class="admin-btn admin-btn--secondary" [routerLink]="['/dashboard/ligas']">Cancelar</button>
      <button class="admin-btn admin-btn--primary" type="submit" [disabled]="isSaving || !league.owner_id">
        {{ isSaving ? 'Salvando...' : 'Salvar liga' }}
      </button>
    </div>
  </form>
</section>
